@if (mappedAddresses()?.length) {
  <div id="vt-address-lookup" class="address-result-box__search-body">
    <div class="address-result-box__search-body__content">
      @for (address of mappedAddresses(); track address) {
        <div
          class="address-result-box__address-item"
          (click)="onAddressSelected(address)">
          <p class="address-result-box__address-item--text">
            {{ address.text }}
          </p>
        </div>
      }
    </div>
  </div>
}
